import styled from '@emotion/styled';

const SearchFormWrapper = styled('aside')({
  maxWidth: '100%',
  display: 'flex',
  flexDirection: 'column',
});

export default SearchFormWrapper;
